import WidgetClassFaqResourceModel from '../../generated/types/model/resource/WidgetClassFaqResourceModel';

export default class WidgetClassFaqResourceViewModel extends WidgetClassFaqResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
